import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/context/AuthContext';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { Toaster } from '@/components/ui/sonner';

import LandingPage from '@/pages/LandingPage';
import LoginPage from '@/pages/LoginPage';
import RegisterPage from '@/pages/RegisterPage';
import DashboardPage from '@/pages/DashboardPage';
import BoardsModePage from '@/pages/BoardsModePage';
import ChapterPickerPage from '@/pages/ChapterPickerPage';
import ChapterHubPage from '@/pages/ChapterHubPage';
import PreTestPage from '@/pages/PreTestPage';
import TestScreenPage from '@/pages/TestScreenPage';
import ResultsPage from '@/pages/ResultsPage';
import HistoryPage from '@/pages/HistoryPage';
import ProfilePage from '@/pages/ProfilePage';
import PricingPage from '@/pages/PricingPage';
import CheckoutPage from '@/pages/CheckoutPage';
import ReferralPage from '@/pages/ReferralPage';
import QbankPage from '@/pages/QbankPage';
import AdminLoginPage from '@/pages/AdminLoginPage';
import AdminDashboardPage from '@/pages/AdminDashboardPage';

import '@/App.css';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />

            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/boards"
              element={
                <ProtectedRoute>
                  <BoardsModePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pick"
              element={
                <ProtectedRoute>
                  <ChapterPickerPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/chapter"
              element={
                <ProtectedRoute>
                  <ChapterHubPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pre-test"
              element={
                <ProtectedRoute>
                  <PreTestPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/test/:sessionId"
              element={
                <ProtectedRoute>
                  <TestScreenPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/report/:sessionId"
              element={
                <ProtectedRoute>
                  <ResultsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/history"
              element={
                <ProtectedRoute>
                  <HistoryPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pricing"
              element={
                <ProtectedRoute>
                  <PricingPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/checkout/:orderId"
              element={
                <ProtectedRoute>
                  <CheckoutPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/referral"
              element={
                <ProtectedRoute>
                  <ReferralPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/qbank"
              element={
                <ProtectedRoute>
                  <QbankPage />
                </ProtectedRoute>
              }
            />

            {/* Admin panel — separate auth (own localStorage key) */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<AdminDashboardPage />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
